import {
  validateFormat,
  validatePresence
} from "ember-changeset-validations/validators";

export default {
  firstName: validatePresence({ presence: true, description: "Le prénom" }),
  lastName: validatePresence({ presence: true, description: "Le nom" }),
  role: validatePresence({ presence: true, description: "Le métier" }),
  email: [validatePresence(true), validateFormat({ type: "email" })],
  secureEmail: validateFormat({
    type: "email",
    description: "L'email sécurisé",
    allowBlank: true
  })
};
